var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import ApiRequestTraits from "./ApiRequestTraits";
import CesiumIonTraits from "./CesiumIonTraits";
import { GeoJsonTraits } from "./GeoJsonTraits";
let GeoJsonCatalogItemTraits = (_dec = traitClass({
  description: "Creates one catalog item from url that points to a geojson file.",
  example: {
    type: "geojson",
    url: "https://tiles.terria.io/terriajs-examples/geojson/bike_racks.geojson",
    name: "geojson example",
    id: "some unique ID"
  }
}), _dec2 = objectArrayTrait({
  type: ApiRequestTraits,
  name: "URLs",
  idProperty: "url",
  description: "Array of GeoJSON URLs to fetch. The GeoJSON features from the URL responses will be merged into one single FeatureCollection. When this trait is specified, the `url` trait is ignored."
}), _dec3 = anyTrait({
  name: "geoJsonData",
  description: "A geojson data object"
}), _dec4 = primitiveTrait({
  type: "string",
  name: "geoJsonString",
  description: "A geojson string"
}), _dec5 = primitiveTrait({
  name: "Response geosjon path",
  type: "string",
  description: "Path to geojson in response. If API response is a list of json objects, this should be the path to the geojson within each object in the list."
}), _dec(_class = (_class2 = class GeoJsonCatalogItemTraits extends mixTraits(GeoJsonTraits, ApiRequestTraits, CesiumIonTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "urls", _descriptor, this);
    _initializerDefineProperty(this, "geoJsonData", _descriptor2, this);
    _initializerDefineProperty(this, "geoJsonString", _descriptor3, this);
    _initializerDefineProperty(this, "responseGeoJsonPath", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "urls", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "geoJsonData", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "geoJsonString", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "responseGeoJsonPath", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { GeoJsonCatalogItemTraits as default };